import { CurrentPricePennies } from "./pricing";

export const promoCode2Pennies = (promos, code) => {
  console.log("promoCode2Pennies: promos:", promos, "code:", code);
  const basePriceInPennies = CurrentPricePennies;
  if (code === "") return basePriceInPennies;

  let pennies = null;
  // Let's hunt for this promo code value; if not found, then no discount!
  // Recall, we dont need to check the timesUsed or expiration etc because the
  // friendly server gave us ONLY promos that CAN be used...
  let promo = promos.find(
    (promo) => promo.name.toLowerCase() === code.toLowerCase()
  );
  if (promo) {
    pennies =
      basePriceInPennies - basePriceInPennies * (promo.percentOff / 100);
    pennies = Math.trunc(pennies);
  }
  console.log("promoCode2Pennies returning:", pennies);
  return pennies;
};
